/**
 * UOM (Unit of Measure) management for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class UOMManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async queryTree(params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/cdp/cdp_uom/extend/queryTree', { params });
  }
}
